import { RegistrationSource } from '../registration/registration-source.enum';

export interface RegistriaRequestCustomerDetails {
  address?: {
    address1: string | undefined;
    address2: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
  };
  email: string | null | undefined;
  phone: string | null | undefined;
  first_name: string | null | undefined;
  last_name: string | null | undefined;
  token: string | undefined;
  locale: string | undefined;
  source: RegistrationSource;
}
